module.exports = __webpack_public_path__ + "static/media/16UNODC10.a82c3122.jpg";